import Swal from "sweetalert2";

/**
 * Show a SweetAlert2 toast
 * @param {string} message - The message to display
 * @param {'success' | 'error' | 'info' | 'warning' | 'question'} icon - The icon type
 * @param {number} timer - Duration in ms
 */
export function showToast(message, icon = 'success', timer = 3000) {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: timer,
        timerProgressBar: true,
        customClass: {
            popup: 'shadow border border-1 rounded-3',
        },
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        }
    });

    Toast.fire({
        icon: icon,
        title: message
    })
}